import React from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/core/Typography';
import ReviewRating from 'components/review/Review/ReviewRating';
import ReviewCard from './ReviewCard';

import './ReviewCardList.scss';

const ReviewCardList = ({ reviews = [], isNearMePage = false }) => {
	return (
		<div className="reviews-section-container">
			<div className="reviews-header-text-container">
				<ReviewRating
					reviewRating={4.3}
					reviewRatingOutOf={5}
					size="large"
				/>
				<H2
					weight="ultraBold"
					size="large"
				>
					{isNearMePage
						? 'SpareFoot Customer Reviews'
						: 'SpareFoot customer reviews'}
				</H2>
				<p>
					SpareFoot has a 4.3 out of 5 star rating from over 41,000
					customer reviews on Trustpilot. See what some of our over
					one million customers say about us.
				</p>
			</div>

			<div className="review-column">
				{!!reviews.length &&
					reviews?.map((card) => (
						<div key={card.id}>
							<ReviewCard
								title={card.title}
								stars={card.stars}
								description={card.text}
								user={card.customerName}
								key={card.customerName}
							/>
						</div>
					))}
			</div>
		</div>
	);
};

ReviewCardList.propTypes = {
	reviews: PropTypes.arrayOf(PropTypes.object),
	isNearMePage: PropTypes.bool,
};

export default ReviewCardList;
